/**
 * Filtro en tiempo real de cards de colecciones (/collections).
 * Case-insensitive, sin acentos, substring + aproximación fuzzy.
 */
(function () {
  const root = document.querySelector('[data-tt-collections]');
  if (!root) return;

  const input = root.querySelector('[data-tt-collections-search]');
  const items = [...root.querySelectorAll('[data-tt-collection-item]')];
  const empty = root.querySelector('[data-tt-collections-empty]');
  if (!input || !items.length) return;

  /* Normaliza: minúsculas + sin diacríticos */
  function normalize(str) {
    return String(str || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  /* Distancia de Levenshtein (aproximación tipográfica) */
  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    const row = Array.from({ length: b.length + 1 }, (_, i) => i);
    for (let i = 0; i < a.length; i++) {
      let prev = i + 1;
      for (let j = 0; j < b.length; j++) {
        const cur =
          a[i] === b[j] ? row[j] : 1 + Math.min(row[j], row[j + 1], prev);
        row[j] = prev;
        prev = cur;
      }
      row[b.length] = prev;
    }
    return row[b.length];
  }

  /* ¿Query aparece como subsecuencia en el título? (ej. "lng" → linguagem) */
  function isSubsequence(haystack, needle) {
    let i = 0;
    for (const ch of haystack) {
      if (ch === needle[i]) i += 1;
      if (i === needle.length) return true;
    }
    return false;
  }

  function matches(title, query) {
    const t = normalize(title);
    const q = normalize(query);
    if (!q) return true;
    if (t.includes(q)) return true;

    const tokens = q.split(/\s+/).filter(Boolean);
    if (tokens.length > 1 && tokens.every((tok) => t.includes(tok))) return true;

    const words = t.split(/[^a-z0-9]+/).filter(Boolean);
    if (words.some((w) => w.startsWith(q))) return true;

    /* Aproximación: subsecuencia o tipo leve en palabras */
    if (q.length >= 3 && isSubsequence(t, q)) return true;

    const maxDist = q.length <= 4 ? 1 : 2;
    return words.some((w) => {
      if (Math.abs(w.length - q.length) > maxDist) return false;
      return levenshtein(w, q) <= maxDist;
    });
  }

  function applyFilter() {
    const q = input.value;
    let visible = 0;

    items.forEach((item) => {
      const title =
        item.getAttribute('data-tt-collection-title') ||
        item.querySelector('.tt-collection-card__title')?.textContent ||
        '';
      const show = matches(title, q);
      item.hidden = !show;
      item.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) visible += 1;
    });

    if (empty) {
      empty.hidden = visible > 0;
    }
  }

  input.addEventListener('input', applyFilter);
  input.addEventListener('search', applyFilter);
})();
